import { lazyLoad } from 'utils/loadable';

export const Taxpayers = lazyLoad(
  () => import('./taxpayers.page'),
  (module) => module.Taxpayers
);
